import Promo1 from "./promo (1).webp";
import Promo2 from "./promo (2).webp";
import Promo3 from "./promo (3).webp";

const promoimages = [Promo1, Promo2, Promo3];

export default promoimages;
